<template>
  <div class="icon-clear-div" @click="clearInputData">
    <i class="iconfont icon-close_circle_surface" />
  </div>
</template>

<script>
export default {
  name: 'CmIconClear',
  methods: {
    clearInputData() {
      this.$emit('clearData')
    }
  }
}
</script>

<style lang="postcss" scoped>
.icon-clear-div {
  position: absolute;
  top: 50%;
  right: 0.04rem;
  width: 0.36rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  margin-top: -0.16rem;
  z-index: 1;
  font-size: 0;
  i {
    color: #ccc;
    font-size: 0.32rem;
  }
}
</style>
